import React, { type JSX } from 'react';
import { type FallbackProps } from 'react-error-boundary';

export class FailedUi extends React.PureComponent<FallbackProps> {

    render(): JSX.Element{
        const isConnectionError = this.props.error?.name === 'ChunkLoadError';
        if (isConnectionError){
            return (
                <div className="error-info">
                    <img src="/imgs/icon-no-wifi.svg"/>
                    <div className="error-title">
                        Whoops!
                    </div>
                    <div className="error-description">
                        No internet connection found
                    </div>
                    <a className="error-action" onClick={() => window.location.reload()}>
                        Click to reload page
                    </a>
                </div>
            );
        }
        return (
            <div className="error-info">
                <div className="error-title">
                    Whoops!
                </div>
                <div className="error-description">
                    {this.props.error?.message}
                </div>
            </div>
        );
    }
}